(function () {
  'use strict';

  if (window.TMFCProductImageNavigation) {
    return;
  }

  var TOOLBAR_SELECTOR = 'body.template-product main#main .product-block-list__item--gallery [data-product-image-navigation]';
  var INSTANCE_KEY = '__tmfcProductImageNavigation';
  var instances = new Set();
  var initializationFrame = null;

  function readContext(toolbar) {
    var section = toolbar.closest('[data-section-type="product"]');
    var galleryItem = toolbar.closest('.product-block-list__item--gallery');
    var gallery = toolbar.closest('.product-gallery');
    var main = toolbar.closest('main#main');

    if (!document.body.classList.contains('template-product') || !section || !galleryItem || !gallery || !main) {
      return null;
    }

    if (toolbar.closest('.modal, .modal__inner, .featured-product')) {
      return null;
    }

    var settings;

    try {
      settings = JSON.parse(section.getAttribute('data-section-settings') || '{}');
    } catch (error) {
      return null;
    }

    if (settings.isQuickView !== false) {
      return null;
    }

    return {
      section: section,
      gallery: gallery
    };
  }

  function ProductImageNavigation(toolbar) {
    var context = readContext(toolbar);

    this.toolbar = toolbar;
    this.section = context ? context.section : null;
    this.gallery = context ? context.gallery : null;
    this.carousel = null;
    this.thumbnailList = null;
    this.entries = [];
    this.indexByMediaId = new Map();
    this.currentIndex = -1;
    this.frame = null;
    this.membershipDirty = false;
    this.destroyed = false;

    this.currentElement = toolbar.querySelector('[data-image-navigation-current]');
    this.totalElement = toolbar.querySelector('[data-image-navigation-total]');
    this.input = toolbar.querySelector('[data-image-navigation-input]');
    this.firstButton = toolbar.querySelector('[data-image-navigation-action="first"]');
    this.previousButton = toolbar.querySelector('[data-image-navigation-action="previous"]');
    this.nextButton = toolbar.querySelector('[data-image-navigation-action="next"]');
    this.lastButton = toolbar.querySelector('[data-image-navigation-action="last"]');

    this.onClick = this._onClick.bind(this);
    this.onKeyDown = this._onKeyDown.bind(this);
    this.onMutations = this._onMutations.bind(this);

    toolbar[INSTANCE_KEY] = this;
    toolbar.addEventListener('click', this.onClick);
    toolbar.addEventListener('keydown', this.onKeyDown);

    if (!this._hasRequiredContext() || !this._rebuild()) {
      this.destroy();
      return;
    }

    this.observer = new MutationObserver(this.onMutations);
    this.observer.observe(this.gallery, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  ProductImageNavigation.prototype._hasRequiredContext = function () {
    return Boolean(
      this.section &&
      this.gallery &&
      this.currentElement &&
      this.totalElement &&
      this.input &&
      this.firstButton &&
      this.previousButton &&
      this.nextButton &&
      this.lastButton
    );
  };

  ProductImageNavigation.prototype._isConnected = function () {
    return !this.destroyed && this.toolbar.isConnected && this.gallery && this.gallery.isConnected;
  };

  ProductImageNavigation.prototype._hide = function () {
    this.toolbar.hidden = true;
  };

  ProductImageNavigation.prototype._rebuild = function () {
    if (!this._isConnected()) {
      return false;
    }

    var carousel = this.gallery.querySelector('.product-gallery__carousel');
    var thumbnailList = this.gallery.querySelector('.product-gallery__thumbnail-list');

    if (!carousel || !thumbnailList) {
      this.entries = [];
      this.indexByMediaId.clear();
      this._hide();
      return false;
    }

    var imageMediaIds = new Set();

    carousel.querySelectorAll('.product-gallery__carousel-item[data-media-type="image"][data-media-id]').forEach(function (slide) {
      var mediaId = slide.getAttribute('data-media-id');

      if (mediaId) {
        imageMediaIds.add(mediaId);
      }
    });

    var entries = [];
    var seenMediaIds = new Set();

    thumbnailList.querySelectorAll('.product-gallery__thumbnail[data-media-id]').forEach(function (thumbnail) {
      var mediaId = thumbnail.getAttribute('data-media-id');

      if (thumbnail.parentNode !== thumbnailList || !imageMediaIds.has(mediaId) || seenMediaIds.has(mediaId)) {
        return;
      }

      seenMediaIds.add(mediaId);
      entries.push({
        mediaId: mediaId,
        thumbnail: thumbnail
      });
    });

    if (entries.length === 0 || entries.length !== imageMediaIds.size) {
      this.entries = [];
      this.indexByMediaId.clear();
      this._hide();
      return false;
    }

    this.carousel = carousel;
    this.thumbnailList = thumbnailList;
    this.entries = entries;
    this.indexByMediaId = new Map();

    entries.forEach(function (entry, index) {
      this.indexByMediaId.set(entry.mediaId, index);
    }, this);

    this.input.min = '1';
    this.input.max = String(entries.length);
    this.totalElement.textContent = String(entries.length);

    return this._syncSelection();
  };

  ProductImageNavigation.prototype._selectedMediaId = function () {
    var selectedSlide = this.carousel.querySelector('.product-gallery__carousel-item.is-selected[data-media-id]');

    if (selectedSlide && this.indexByMediaId.has(selectedSlide.getAttribute('data-media-id'))) {
      return selectedSlide.getAttribute('data-media-id');
    }

    var selectedThumbnail = this.thumbnailList.querySelector('.product-gallery__thumbnail.is-nav-selected[data-media-id]');

    if (selectedThumbnail && this.indexByMediaId.has(selectedThumbnail.getAttribute('data-media-id'))) {
      return selectedThumbnail.getAttribute('data-media-id');
    }

    return null;
  };

  ProductImageNavigation.prototype._syncSelection = function () {
    if (!this._isConnected() || this.entries.length === 0) {
      this._hide();
      return false;
    }

    var mediaId = this._selectedMediaId();

    if (!mediaId) {
      this.currentIndex = -1;
      this._hide();
      return false;
    }

    var index = this.indexByMediaId.get(mediaId);
    var position = index + 1;
    var total = this.entries.length;

    this.currentIndex = index;

    if (this.currentElement.textContent !== String(position)) {
      this.currentElement.textContent = String(position);
    }

    if (document.activeElement !== this.input) {
      this.input.value = String(position);
      this.input.removeAttribute('aria-invalid');
    }

    this.firstButton.disabled = index === 0;
    this.previousButton.disabled = index === 0;
    this.nextButton.disabled = index === total - 1;
    this.lastButton.disabled = index === total - 1;
    this.toolbar.hidden = false;

    return true;
  };

  ProductImageNavigation.prototype._navigateTo = function (index) {
    if (!Number.isInteger(index) || index < 0 || index >= this.entries.length) {
      return;
    }

    var entry = this.entries[index];

    if (!entry.thumbnail.isConnected || entry.thumbnail.parentNode !== this.thumbnailList) {
      this._schedule(true);
      return;
    }

    entry.thumbnail.click();
    this._schedule(false);
  };

  ProductImageNavigation.prototype._goToInput = function () {
    var value = Number(this.input.value);

    if (!Number.isInteger(value) || value < 1 || value > this.entries.length) {
      this.input.setAttribute('aria-invalid', 'true');
      return;
    }

    this.input.removeAttribute('aria-invalid');
    this._navigateTo(value - 1);
  };

  ProductImageNavigation.prototype._onClick = function (event) {
    var button = event.target.closest('[data-image-navigation-action]');

    if (!button || !this.toolbar.contains(button) || button.disabled) {
      return;
    }

    switch (button.getAttribute('data-image-navigation-action')) {
      case 'first':
        this._navigateTo(0);
        break;
      case 'previous':
        this._navigateTo(this.currentIndex - 1);
        break;
      case 'next':
        this._navigateTo(this.currentIndex + 1);
        break;
      case 'last':
        this._navigateTo(this.entries.length - 1);
        break;
      case 'go':
        this._goToInput();
        break;
    }
  };

  ProductImageNavigation.prototype._onKeyDown = function (event) {
    if (event.key === 'Enter' && event.target === this.input) {
      event.preventDefault();
      this._goToInput();
    }
  };

  ProductImageNavigation.prototype._onMutations = function (mutations) {
    var rebuild = false;
    var sync = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        if (
          mutation.target === this.carousel ||
          this.carousel.contains(mutation.target) ||
          mutation.target === this.thumbnailList ||
          this.thumbnailList.contains(mutation.target)
        ) {
          rebuild = true;
        }

        return;
      }

      if (
        mutation.target.matches('.product-gallery__carousel-item[data-media-id], .product-gallery__thumbnail[data-media-id]')
      ) {
        sync = true;
      }
    }, this);

    if (rebuild) {
      this._schedule(true);
    } else if (sync) {
      this._schedule(false);
    }
  };

  ProductImageNavigation.prototype._schedule = function (rebuild) {
    if (this.destroyed) {
      return;
    }

    this.membershipDirty = this.membershipDirty || rebuild;

    if (this.frame !== null) {
      return;
    }

    this.frame = window.requestAnimationFrame(function () {
      var shouldRebuild = this.membershipDirty;

      this.frame = null;
      this.membershipDirty = false;

      if (shouldRebuild) {
        this._rebuild();
      } else {
        this._syncSelection();
      }
    }.bind(this));
  };

  ProductImageNavigation.prototype.refresh = function (rebuild) {
    this._schedule(Boolean(rebuild));
  };

  ProductImageNavigation.prototype.destroy = function () {
    if (this.destroyed) {
      return;
    }

    this.destroyed = true;
    this._hide();
    this.toolbar.removeEventListener('click', this.onClick);
    this.toolbar.removeEventListener('keydown', this.onKeyDown);

    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.frame !== null) {
      window.cancelAnimationFrame(this.frame);
    }

    if (this.toolbar[INSTANCE_KEY] === this) {
      delete this.toolbar[INSTANCE_KEY];
    }

    instances.delete(this);
  };

  function initializeAll() {
    initializationFrame = null;

    instances.forEach(function (instance) {
      if (!instance._isConnected()) {
        instance.destroy();
      }
    });

    document.querySelectorAll(TOOLBAR_SELECTOR).forEach(function (toolbar) {
      var existingInstance = toolbar[INSTANCE_KEY];

      if (existingInstance && !existingInstance.destroyed) {
        existingInstance.refresh(true);
        return;
      }

      var instance = new ProductImageNavigation(toolbar);

      if (!instance.destroyed) {
        instances.add(instance);
      }
    });
  }

  function scheduleInitialization() {
    if (initializationFrame !== null) {
      return;
    }

    initializationFrame = window.requestAnimationFrame(initializeAll);
  }

  function refreshEventSection(event, rebuild) {
    var section = event.target.closest ? event.target.closest('[data-section-type="product"]') : null;

    instances.forEach(function (instance) {
      if (!section || instance.section === section) {
        instance.refresh(rebuild);
      }
    });
  }

  document.addEventListener('variant:change', function (event) {
    refreshEventSection(event, false);
  });
  document.addEventListener('variant:changed', function (event) {
    refreshEventSection(event, false);
  });
  document.addEventListener('product:rerender', function (event) {
    refreshEventSection(event, true);
    scheduleInitialization();
  });
  document.addEventListener('shopify:section:load', scheduleInitialization);
  document.addEventListener('shopify:section:unload', scheduleInitialization);
  window.addEventListener('pageshow', scheduleInitialization);
  window.addEventListener('popstate', scheduleInitialization);

  window.TMFCProductImageNavigation = {
    refresh: scheduleInitialization
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitialization, { once: true });
  } else {
    scheduleInitialization();
  }
})();
